import map from "lodash/map";
import omitBy from "lodash/omitBy";
import React from "react";
import { useSelector } from "react-redux";

import { getCostCenters } from "../../../../actions/employers/costCenterActions";
import FormContextDropdownSelect from "../../../employer/JobCasts/create/formContextInputs/FormContextDropdownSelect";

const CostCenterField = ({ costCenterToExclude }) => {
  const costCenters = useSelector(getCostCenters);

  let filteredCostCenters = {};

  if (costCenterToExclude) {
    filteredCostCenters = omitBy(
      costCenters,
      (costCenter) => costCenter.id === costCenterToExclude.id
    );
  } else {
    filteredCostCenters = costCenters;
  }

  const options = map(filteredCostCenters, (costCenter) => ({
    value: costCenter.attributes.id,
    label: costCenter.attributes.name,
  }));

  return (
    <FormContextDropdownSelect
      id="costCenterId"
      label="Cost Center"
      options={options}
    />
  );
};

export default CostCenterField;
